<template>
  <div class="div_lang" v-loading="loading">
    <div class="detail_msg_mo">
      <img class="sign-header-img" src="@/assets/img/logo.png" />
      <div style="float: left;overflow: hidden;height: 40px;padding-top: 5px">
        <el-button @click="back" class="bc_butn_o">上一步</el-button>
      </div>
      <!-- 当前页数/总页数 -->
      <div class="detail_msg_test">
        {{ contractName }}
        (
        <span>{{ page_Abbreviation_1 > numPages ? numPages : page_Abbreviation_1 }}</span>
        {{ ' / ' + numPages + ')' }}
      </div>
      <!-- 分辨率缩小 -->
      <el-select id="guang_b" v-model="value" placeholder="请选择" class="el_select" @change="get_value()">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="el_row" id="el_row">
      <!-- 展开收起 -->
      <div @click="zhan()" class="zhan">
        <i class="el-icon-caret-right" v-if="isCollapse"></i>
        <i class="el-icon-caret-left" v-else></i>
      </div>
      <el-row :gutter="20">
        <pdf class="Abbreviation_pdf" :src="pdfUrl" :page="1" style="display: none ;width: 100px;height: 100px"></pdf>
        <el-col :span="20" class="el-col_17">
          <!-- 缩略图 -->
          <div class="el-menu-vertical-demo" :class="isCollapse ? 'el-menu-vertical-demo_0' : ''">
            <div class="top_div">缩略图</div>
            <div class="Abbreviation" id="Abbreviation">
              <div v-for="(i, t) in img_data_s" :v-model="page_Abbreviation" class="Abbreviation_div" @click="get_Abbreviation(t)" :key="t + '002'">
                <!--                                    <img class="Abbreviation_pdf" @error="handleError" :src="i.imageUri| fileToUrl(solv_img)" :class="i.pageIndex == page_Abbreviation?'onSliet':''  "/>-->
                <el-image
                  draggable="false"
                  class="Abbreviation_pdf"
                  :src="i.imageUri | fileToUrl(solv_img)"
                  :class="i.pageIndex == page_Abbreviation ? 'onSliet' : ''"
                ></el-image>

                <div class="onSliet_o_s" :class="i.pageIndex == page_Abbreviation ? 'onSliet_o' : ''">{{ i.pageIndex + 1 }}</div>
              </div>
            </div>
          </div>

          <div class="box_body" id="box_body">
            <div class="detail_msg_m" id="detail_msg_m" v-loading="loading_one_s">
              <div v-for="i in numPages" class="detail_m_pdf" :key="i">
                <pdf class="pdf_o" :src="pdfUrl" @progress="loadedRatio = $event" @page-loaded="pageLoaded($event)" :page="i"></pdf>
              </div>

              <div v-for="(it, is) in imgs" :key="is + '-only'">
                <div class="img_ong" v-if="imgs && it.signType == 'sign'">
                  <img
                    class="img"
                    @mousedown="move"
                    :id="'img-' + is"
                    :style="{
                      top: it.top ? it.top + 'px' : '',
                      left: it.left ? it.left + 'px' : '',
                      width: it.width ? it.width + 'px' : '',
                      height: it.height ? it.height + 'px' : ''
                    }"
                    :src="it.sealSaveID | fileToUrl(mySignature_file)"
                    alt
                    fit="contain"
                    ref="img"
                  />
                  <div
                    class="delButn"
                    @click="del(is)"
                    :id="'div-' + is"
                    :style="{ top: it.top ? it.top - 10 + 'px' : '', left: it.left ? it.left + it.width - 10 + 'px' : '' }"
                  >
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="'#el-icon-my-deletestamp'" />
                    </svg>
                  </div>
                </div>
                <div class="img_ong" v-if="imgs && it.signType == 'seal'">
                  <img
                    class="img"
                    :style="{
                      top: it.top ? it.top + 'px' : '',
                      left: it.left ? it.left + 'px' : '',
                      width: it.width ? it.width + 'px' : '',
                      height: it.height ? it.height + 'px' : ''
                    }"
                    :id="'img-' + is"
                    :src="it.sealSaveID | fileToUrl(mySeal_file)"
                    alt
                    ref="img"
                    @mousedown="move"
                    fit="contain"
                  />
                  <div
                    class="delButn"
                    @click="del(is)"
                    :id="'div-' + is"
                    :style="{ top: it.top ? it.top - 10 + 'px' : '', left: it.left ? it.left + it.width - 10 + 'px' : '' }"
                  >
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="'#el-icon-my-deletestamp'" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <!-- 我的印章 -->
          <el-tabs type="border-card" v-if="serial != 2">
            <template v-if="userType == 0 && mySeal.length > 0">
              <el-tab-pane label="我的印章" v-if="userType == 1 || representType == 'company' || userId != id">
                <el-collapse accordion v-model="activeName" class="el_collapse el-col_4" v-bind:style="{ height: tableHeight + 'px' }">
                  <el-collapse-item v-for="(item2, index) in mySeal" :key="index" class="el-collapse_item" :name="index">
                    <div slot="title" class="coil_test">{{ item2.name }}</div>
                    <el-image class="img_seal" draggable="false" :src="item2.sealSaveID | fileToUrl(mySeal_file)" fit="contain">
                      <div slot="error" class="image-slot image-slot_one" v-if="!$options.filters.fileToUrl(item2.sealSaveID, mySeal_file, false)">
                        <img src="@/assets/img/user/signature.png" />
                        <p>签章丢失</p>
                      </div>
                    </el-image>
                    <div>
                      <el-button v-if="$options.filters.fileToUrl(item2.sealSaveID, mySeal_file, false)" class="want_sign" @click="add_img(item2, 'seal')">我要签署</el-button>
                      <el-button v-else disabled class="want_sign want_sign_s">我要签署</el-button>
                    </div>
                  </el-collapse-item>
                  <!--                                <el-button v-if="mySeal.length ==0" class="want_sign want_sign_1" @click="$router.push({name:'mySignature' })">没有印章,去上传</el-button>-->
                  <router-link v-if="mySeal.length == 0" class="want_sign want_sign_1" target="_blank" :to="{ name: 'mySignature' }">没有印章,去上传</router-link>
                </el-collapse>
              </el-tab-pane>
            </template>
            <template v-if="userType == 1">
              <el-tab-pane label="我的印章" v-if="userType == 1 || representType == 'company' || userId != id">
                <el-collapse accordion v-model="activeName" class="el_collapse el-col_4" v-bind:style="{ height: tableHeight + 'px' }">
                  <el-collapse-item v-for="(item2, index) in mySeal" :key="index" class="el-collapse_item" :name="index">
                    <div slot="title" class="coil_test">{{ item2.name }}</div>
                    <el-image class="img_seal" draggable="false" :src="item2.sealSaveID | fileToUrl(mySeal_file)" fit="contain">
                      <div slot="error" class="image-slot image-slot_one" v-if="!$options.filters.fileToUrl(item2.sealSaveID, mySeal_file, false)">
                        <img src="@/assets/img/user/signature.png" />
                        <p>签章丢失</p>
                      </div>
                    </el-image>
                    <div>
                      <el-button v-if="$options.filters.fileToUrl(item2.sealSaveID, mySeal_file, false)" class="want_sign" @click="add_img(item2, 'seal')">我要签署</el-button>
                      <el-button v-else disabled class="want_sign want_sign_s">我要签署</el-button>
                    </div>
                  </el-collapse-item>
                  <!--                                <el-button v-if="mySeal.length ==0" class="want_sign want_sign_1" @click="$router.push({name:'mySignature' })">没有印章,去上传</el-button>-->
                  <router-link v-if="mySeal.length == 0" class="want_sign want_sign_1" target="_blank" :to="{ name: 'mySignature' }">没有印章,去上传</router-link>
                </el-collapse>
              </el-tab-pane>
            </template>
            <template v-if="userType == 0">
              <el-tab-pane label="我的签名" v-if="(userType == 0 && representType == 'own') || userId != id">
                <el-collapse accordion v-model="activeName" class="el_collapse el-col_4" v-bind:style="{ height: tableHeight + 'px' }">
                  <el-collapse-item v-for="(item, index) in mySignature" :key="index" class="el-collapse_item" :name="index">
                    <div slot="title" class="coil_test">{{ item.name }}</div>
                    <el-image class="img_seal" draggable="false" :src="item.signatureSaveID | fileToUrl(mySignature_file)" fit="contain">
                      <div slot="error" class="image-slot image-slot_one" v-if="!$options.filters.fileToUrl(item.signatureSaveID, mySignature_file, false)">
                        <img src="@/assets/img/user/Signature_s.png" />
                        <p>签名丢失</p>
                      </div>
                    </el-image>
                    <div>
                      <el-button
                        v-if="$options.filters.fileToUrl(item.signatureSaveID, mySignature_file, false)"
                        class="want_sign"
                        @click="add_img(item, 'sign')"
                      >我要签署</el-button>
                      <el-button v-else disabled class="want_sign want_sign_s">我要签署</el-button>
                    </div>
                  </el-collapse-item>
                  <!--                                <el-button v-if="mySignature.length ==0" class="want_sign want_sign_1"  @click="$router.push({name:'mySignature' })">没有签名,去上传</el-button>-->
                  <router-link v-if="mySignature.length == 0" class="want_sign want_sign_1" target="_blank" :to="{ name: 'mySignature' }">没有印章,去上传</router-link>
                </el-collapse>
              </el-tab-pane>
            </template>
          </el-tabs>
          <!-- 签署 -->
          <div class="Sign_immediately">
            <div class="Sign_immediately_top">签署日期</div>
            <div class="Sign_immediately_button">{{ newDate | timeFormat('yyyy-mm-dd') }}</div>
            <el-button :loading="loading_fa" v-if="serial == 2" class="want_sign" @click="contract_issue()">发布</el-button>
            <el-button v-if="serial == 1" class="want_sign" @click="signatureVerification()">签署并发布</el-button>
            <el-button v-if="serial == 3" class="want_sign" @click="signatureVerification()">签署</el-button>
            <el-button :loading="loading_del" v-if="serial == 3" class="want_sign" @click="del_sign()">拒签</el-button>
          </div>
        </el-col>
      </el-row>
      <el-dialog title="验证码校验" :close-on-click-modal="false" v-dialogDrag :visible.sync="dialogVisible" width="617" center :before-close="handleDialogClose">
        <el-form ref="form" :model="user" label-width="80px">
          <div class="tanzheng">
            签署验证码已发送至
            <span>{{ contactPhone }}</span>手机上,请注意查收并填写至下方
          </div>
          <el-form-item label="验证码">
            <div class="verifyCode_one">
              <el-input class="input_one" maxlength="6" v-model="user.code" placeholder="请输入验证码"></el-input>
              <el-button :loading="loading_button" @click="verify ? get_code() : ''" :class="['butn', verify ? '' : 'on']">
                {{
                verify ? '发送验证码' : '已发送(' + time + ')'
                }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleDialogClose">取 消</el-button>
          <el-button :loading="loading_yes" :disabled="disabled" type="primary" @click="sign_code()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'signature_of_documents',
  components: { pdf },
  data() {
    return {
      tableHeight: document.body.clientHeight * 0.5,
      options: [
        {
          value: 0.8,
          label: '80%'
        },
        {
          value: 1,
          label: '100%'
        },
        {
          value: 1.5,
          label: '150%'
        },
        {
          value: 2,
          label: '200%'
        },
        {
          value: 3,
          label: '自适应'
        }
      ],
      value: 1.5,

      loadedRatio: 0,

      contractId: this.$route.query.id,
      contractId_one: this.$route.query.contractId,
      serial: this.$route.query.serial,
      type: this.$route.query.type,
      mySeal: {},
      mySeal_file: {},
      mySignature: {},
      mySignature_file: {},
      imgs: [],
      user: {},
      newDate: new Date(),
      verify: true,
      time: 60,
      dialogVisible: false,
      loading: false,
      loading_one_s: false,
      disabled: false,
      del_seal_dialog_2: false,
      aimg: {},
      aimg_file: {},
      mesla: {},
      img_width: 0,
      img_height: '',
      pdfUrl: '',
      numPages: 1,
      activeIndex: 0,
      activeName: 0,
      det_msg: '',
      page_Abbreviation: 0,
      page_Abbreviation_1: 1,
      isCollapse: false,
      loading_button: false,
      loading_yes: false,
      loading_fa: false,
      loading_del: false,
      contractName: '',
      contactPhone: '',
      nws: '',
      solv_img: {},
      img_data_s: [],
      img_data: [],
      errobj: {},
      representType: '',
      userId: '',
      id: this.$SIF.getLocalStorage('userInfo').id
    }
  },
  // 监听滑动高度
  mounted() {
    var that = this
    var dom = document.getElementById('box_body')
    // document.getElementById("inner").scrollHeight
    dom.addEventListener('scroll', function () {
      that.det_msg_o(dom.scrollTop)
    })
  },
  created() {
    this.contractId = this.$route.query.id
    this.contractId_one = this.$route.query.contractId
    this.serial = this.$route.query.serial
    this.contractJoinUserId = this.$route.query.contractJoinUserId
    var ph = this.$SIF.getLocalStorage('userInfo').contactPhone
    var ph_a = ph.substring(0, 3)
    var ph_b = ph.substring(7, 11)
    this.contactPhone = ph_a + '****' + ph_b
    // // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
    if (this.$route.query.type == 1) {
      this.get_contract_one()
    } else {
      this.get_contract()
    }
    this.userType = this.$SIF.getLocalStorage('userInfo').userType
    if (this.userType == 0) {
      this.get_mySignature()
    }
    // this.get_mySeal()

    // this.get_contract_join_user();
    this.get_contract()
    this.add_recently_contract()
  },
  beforeDestroy() {
    if (this.interval) {
      this.verify = true
      this.time = 60
      clearInterval(this.interval)
    }
  },
  methods: {
    pageLoaded(e) {
      if (e == 1) {
        setTimeout(() => {
          this.loading = false
          var add_input = document.getElementById('guang_b')
          add_input.type = 'button'
        }, 1000)
      }
    },
    // 图片加载失败
    handleError(e) {
      e.target.src = require('@/assets/img/loding.gif')
    },

    handleDialogClose() {
      // if (this.interval) {
      //     this.verify = true;
      //     this.time = 60;
      //     clearInterval(this.interval);
      // }
      this.dialogVisible = false
    },
    get_value() {
      // this.loading_one_s = true

      let p = new Promise((resolve, reject) => {
        var that = this
        let img = new Image()
        img.src = that.aimg_file.url
        let timer = setInterval(function () {
          that.img_width = img.width
          that.img_height = img.height
          if (img.width > 0 || img.height > 0) {
            clearInterval(timer)
            resolve({
              width: img.width,
              height: img.height
            })
            var a = document.getElementById('detail_msg_m')
            if (that.value == 3) {
              var nw = document.getElementById('box_body').offsetWidth
              that.nws = (nw / that.img_width).toFixed(4)
              a.style.width = nw + 'px'
            } else {
              a.style.width = that.img_width * that.value + 'px'
            }
            if (that.value == 3 && that.imgs) {
              for (var s = 0; s < that.imgs.length; s++) {
                var size = that.imgs[s].size.split('*')
                that.imgs[s].width = Math.ceil(((size[0] * 72) / 25.4) * that.nws)
                that.imgs[s].height = Math.ceil(((size[1] * 72) / 25.4) * that.nws)
                that.imgs[s].left = Math.ceil((that.imgs[s].left / that.imgs[s].multiplying_power) * that.nws)
                that.imgs[s].top = Math.ceil((that.imgs[s].top / that.imgs[s].multiplying_power) * that.nws)
                that.imgs[s].multiplying_power = that.nws
              }
            } else if (that.imgs) {
              for (var s_0 = 0; s_0 < that.imgs.length; s_0++) {
                var size_0 = that.imgs[s_0].size.split('*')
                that.imgs[s_0].width = Math.ceil(((size_0[0] * 72) / 25.4) * that.value)
                that.imgs[s_0].height = Math.ceil(((size_0[1] * 72) / 25.4) * that.value)
                that.imgs[s_0].left = Math.ceil((that.imgs[s_0].left / that.imgs[s_0].multiplying_power) * that.value)
                that.imgs[s_0].top = Math.ceil((that.imgs[s_0].top / that.imgs[s_0].multiplying_power) * that.value)
                that.imgs[s_0].multiplying_power = that.value
              }
            }
          }
        }, 50)
        // setTimeout(() =>{
        //     let img = new Image();
        //     img.src = this.aimg_file.url;
        //     this.img_width = img.width
        //     this.img_height = img.height
        //
        //
        //
        //
        //
        //     // this.loading_one_s = false
        // },1000);
      })

      // this.det_msg_o()
    },
    zhan() {
      this.isCollapse = !this.isCollapse
      var d = document.getElementById('box_body')
      if (this.isCollapse) {
        d.style.width = '-webkit-calc(100%)'
        d.style.width = '-moz-calc(100%)'
        d.style.width = 'calc(100%)'

        setTimeout(() => {
          this.get_value()
        }, 600)
        // d.style.transition = 'all 1s'
      } else {
        d.style.width = '-webkit-calc(100% - 150px)'
        d.style.width = '-moz-calc(100% - 150px)'
        d.style.width = 'calc(100% - 150px)'
        setTimeout(() => {
          this.get_value()
        }, 600)
        // d.style.transition = 'all 1s'
      }
    },
    // 添加最近文件
    add_recently_contract() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.contract + '/add/recently-contract',
        data: {
          contractId: this.contractId_one
        },
        succFun: res => {}
      })
    },
    // 验证是否已经添加印章
    signatureVerification() {
      if (this.imgs.length > 0) {
        this.dialogVisible = true
        // contactPhone
        if (this.time < 59) {
          return
        }
        this.get_code()
      } else {
        this.$message({
          message: '请先添加印章',
          type: 'warning'
        })
        return
      }
    },
    // 合同滚动距离
    det_msg_o(i) {
      this.det_msg = i
      let div = document.querySelector('.pdf_o canvas')
      this.page_Abbreviation = Math.ceil(this.det_msg / div.offsetHeight) - 1
      this.page_Abbreviation_1 = Math.ceil(this.det_msg / div.offsetHeight)
      if (this.page_Abbreviation_1 == 0) {
        this.page_Abbreviation_1 = 1
      }
      if (this.page_Abbreviation < 0) {
        this.page_Abbreviation = 0
      }
      if (div.offsetHeight < document.getElementById('box_body').offsetHeight) {
        if (document.getElementById('detail_msg_m').scrollHeight - this.det_msg < document.getElementById('box_body').offsetHeight) {
          this.page_Abbreviation_1 = this.page_Abbreviation_1 + 1
          this.page_Abbreviation = this.page_Abbreviation + 1
        }
      }
      if (this.page_Abbreviation == this.numPages) {
        this.page_Abbreviation = this.numPages - 1
      }

      // if(this.page_Abbreviation>3){
      this.Abbreviation_o(this.page_Abbreviation)
      // }
    },
    // 拒绝签署合同
    del_sign() {
      this.loading_del = true
      this.$confirm('确定要拒绝签署该合同吗?请谨慎操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$SIF.httpPost({
            url: this.$SIF._serve.manage + '/contract/refuse/sign',
            data: {
              contractJoinUserId: this.contractJoinUserId
            },
            succFun: res => {
              if (res.code == 10000) {
                this.$message({
                  message: '合同拒签',
                  type: 'success'
                })
                this.$router.go(-1)
                this.loading = false
                this.loading_del = false
              } else {
                this.loading = false
                this.loading_del = false
                this.$message({
                  message: res.msg,
                  type: 'warning'
                })
              }
            },
            failFun: res => {
              this.loading = false
              this.loading_del = false
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        })
        .catch(() => {
          this.loading = false
          this.loading_del = false
        })
    },
    // 点击左侧图片
    get_Abbreviation(i) {
      this.page_Abbreviation = i
      this.det_msg_o()
      let div = document.querySelector('.pdf_o canvas')
      var div_s = document.getElementById('box_body')
      var x = div.offsetHeight * i + 10
      div_s.scrollTop = 0

      var u_agent = navigator.userAgent
      if (u_agent.indexOf('Edge') > -1) {
        div_s.scrollTop = x
      } else if (u_agent.indexOf('Chrome') > -1) {
        div_s.scrollTop = x
      } else {
        div_s.scrollTop = x
      }
    },
    // 左侧图片滑动高度
    Abbreviation_o(i) {
      if (i == 'NaN') {
        i = 0
      }
      var u_agent = navigator.userAgent
      var div = document.getElementById('Abbreviation')
      var x = 200 * (i - 1)
      if (u_agent.indexOf('Edge') > -1) {
        div.scrollTop = x
      } else if (u_agent.indexOf('Chrome') > -1) {
        div.scrollTop = x
      } else {
        div.scrollTop = x
      }

      return
    },
    //加载pdf
    pdfTask(pdfUrl) {
      var self = this
      if (process.env.NODE_ENV === 'development') {
        var liet = pdfUrl.split('/filePath2')
        self.pdfUrl = pdf.createLoadingTask(self.$SIF.get_file + liet[1])
      } else {
        self.pdfUrl = pdf.createLoadingTask(pdfUrl)
      }
      self.pdfUrl
        .then(pdf => {
          self.numPages = pdf.numPages
          // self.pdfUrl =  pdfUrl
        })
        .catch(err => {
          console.error('pdf加载失败')
        })
      // setTimeout(() =>{
      //     self.loading =false
      // },8000);
    },
    // 获取是否有余额
    getMeals() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.meal + '/centreBalanceController/getUserId',
        succFun: res => {
          this.mesla = res.data
        },
        failFun: res => {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    del(is) {
      this.imgs.splice(is, 1)
      // this.$confirm('确定要删除该印章/签名吗', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      // }).then(() => {
      //
      // });
    },
    // 添加印章
    add_img(i, t) {
      i.signType = t
      i.top = this.det_msg + 100
      i.left = 100
      if (this.value == 3) {
        i.multiplying_power = this.nws
      } else {
        i.multiplying_power = this.value
      }

      var size = i.size.split('*')
      i.width = Math.ceil(((size[0] * 72) / 25.4) * i.multiplying_power)
      i.height = Math.ceil(((size[1] * 72) / 25.4) * i.multiplying_power)
      if (t == 'sign') {
        i.sealSaveID = i.signatureSaveID
      }
      i = JSON.parse(JSON.stringify(i))
      this.imgs.push(i)
      let div = document.querySelector('.pdf_o canvas')
      let div_height = div.offsetHeight
      this.imgs[this.imgs.length - 1].currentPage = Math.ceil(this.det_msg / div_height)
    },
    // 印章移动
    move(e) {
      let odiv = e.target //获取目标元素
      e.preventDefault()
      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft
      let disY = e.clientY - odiv.offsetTop
      var width = document.getElementById('detail_msg_m').offsetWidth
      var height = document.getElementById('detail_msg_m').offsetHeight
      document.onmousemove = e => {
        var newData = odiv.id.split('-')
        let left = e.clientX - disX
        let top = e.clientY - disY
        if (left < 4) {
          left = 6
        }
        if (top < 0) {
          top = 1
        }
        if (left > width - odiv.offsetWidth - 4) {
          left = width - odiv.offsetWidth - 6
        }
        let div = document.querySelector('.pdf_o canvas')
        let div_height = div.offsetHeight
        if (top > div_height * this.numPages - odiv.offsetHeight - 4) {
          top = div_height * this.numPages - odiv.offsetHeight - 4
        }
        this.$set(this.imgs[newData[1]], 'left', left)
        this.$set(this.imgs[newData[1]], 'top', top)
      }
      document.onmouseup = e => {
        document.onmousemove = null
        document.onmouseup = null
      }
    },
    back() {
      this.$router.go(-1) //返回上一层
    },
    // 我的签名
    get_mySignature() {
      var that = this
      this.$axios.post(this.$SIF._serve.signature + '/contract-signature/usersignature').then(
        res => {
          if (res.data.code == 10000) {
            var dt = res.data.data,
              arr = []
            for (var k = 0; k < dt.length; k++) {
              arr.push(dt[k].signatureSaveID)
            }
            this.mySignature = dt
            that.$SIF.downloadListFile({
              params: { ids: arr },
              succFun: function (res) {
                that.mySignature_file = res.data
              }
            })
          }
        },
        res => {}
      )
    },
    //我的印章
    get_mySeal() {
      var url = this.userType == 0 ? this.$SIF._serve.manage + '/query/auth-seal' : this.$SIF._serve.seal + '/contract-seal/companySeal'
      var that = this
      if (this.userId == this.id) {
        this.authorizeCompanyIdOne = this.authorizeCompanyId
      } else {
        this.authorizeCompanyIdOne = ''
      }
      var date = {
        name: '',
        sealType: '',
        authorizeCompanyId: this.authorizeCompanyIdOne
      }
      this.$axios.post(url, date).then(
        res => {
          if (res.data.code == 10000) {
            // var dt = res.data.data,
            let { data } = res.data
            //   arr = [],
            //   dts = []
            if (data) {
              // for (var k = 0; k < dt.length; k++) {
              //   if (dt[k].certification == 1) {
              //     arr.push(dt[k].sealSaveID)
              //     dts.push(dt[k])
              //   }
              // }
              let showSeals = data.filter(item => item.certification === 1 && item.status === 1)
              this.mySeal = showSeals
              that.$SIF.downloadListFile({
                params: { ids: showSeals.map(item => item.sealSaveID) },
                succFun: function (res) {
                  that.mySeal_file = res.data
                }
              })
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        },
        res => {}
      )
    },
    createComprisonFunction(propertyName) {
      return function (object1, object2) {
        var value1 = object1[propertyName]
        var value2 = object2[propertyName]
        if (value1 < value2) {
          return -1
        } else if (value1 > value2) {
          return 1
        } else {
          return 0
        }
      }
    },
    //获取合同pdf 设置初始化数据
    get_contract() {
      this.loading = true
      this.$SIF.httpPost({
        url: this.$SIF._serve.manage + '/query/contract-by-id',
        data: {
          contractId: this.contractId_one
        },
        succFun: res => {
          this.contractName = res.data.contractName
          this.representType = res.data.representType
          this.authorizeCompanyId = res.data.representIndex
          this.userId = res.data.userId
          this.aimg = JSON.parse(res.data.docImageList)
          this.get_mySeal()
          var img_url = []
          this.img_data_s = []
          for (var it in this.aimg) {
            if (this.aimg[it].imageUri) {
              img_url.push(this.aimg[it].imageUri)
              this.img_data_s.push(this.aimg[it])
              this.img_data_s = this.img_data_s.sort(this.createComprisonFunction('pageIndex'))
            }
          }
          this.$SIF.downloadListFile({
            params: { ids: img_url },
            succFun: res => {
              this.solv_img = res.data
            },
            failFun: res => {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
              this.loading = false
            }
          })
          this.$SIF.downloadFile({
            params: { id: this.aimg[0].imageUri },
            succFun: res => {
              this.aimg_file = res.data
              let p = new Promise((resolve, reject) => {
                let img = new Image()
                img.src = this.aimg_file.url
                let timer = setInterval(function () {
                  if (img.width > 0 || img.height > 0) {
                    resolve({
                      width: img.width,
                      height: img.height
                    })
                    this.img_width = img.width
                    this.img_height = img.height
                    var a = document.getElementById('detail_msg_m')
                    a.style.width = this.img_width * 1.5 + 'px'
                    // a.style.height =this.img_height+'px'
                    // var d = document.getElementById("box_body")
                    //     d.style.height =this.img_height+'px'
                    clearInterval(timer)
                  }
                }, 50)
              })
              p.then(data => {
                this.img_data = data
              })
            },
            failFun: res => {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
              this.loading = false
            }
          })

          this.$SIF.downloadFile({
            params: { id: res.data.pdfFileSaveId },
            succFun: res => {
              this.pdfsrc = res.data.url
              this.pdfTask(this.pdfsrc)
            },
            failFun: res => {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
              this.loading = false
            }
          })
        },
        failFun: res => {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
          this.loading = false
        }
      })
    },
    get_contract_one() {
      this.$SIF.downloadFile({
        params: { id: this.contractId_one },
        succFun: res => {
          this.pdfsrc = res.data.url
          this.pdfTask(this.pdfsrc)
        },
        failFun: res => {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
          this.loading = false
        }
      })
    },

    // 批量删除印章
    del_contract_detail() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.contract + '/function/batch-delete/contract-detail',
        data: {
          contractJoinUserId: this.contractJoinUserId
        },
        succFun: res => {
          this.add_contract_detail()
        },
        failFun: res => {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
          this.loading = false
        }
      })
    },
    // 发起合同
    contract_issue() {
      if (!this.mesla) {
        this.$confirm('套餐余额不足，请重新购买套餐', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({ name: 'buyMeal' })
        })
        return
      }
      this.loading_fa = true
      this.loading = true
      this.$SIF.httpPost({
        url: this.$SIF._serve.manage + '/contract/issue',
        data: {
          contractId: this.contractId_one
        },
        succFun: res => {
          if (this.serial == 1) {
            this.del_contract_detail()
            // this.add_contract_detail()
            return
          }
          this.loading = false
          this.$message({
            message: '合同发布成功',
            type: 'success'
          })
          this.$router.go(-2)
          this.loading_fa = false
        },
        failFun: res => {
          this.loading_fa = false
          this.loading = false
          this.dialogVisible = false
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    // 批量添加印章或签名
    add_contract_detail() {
      let div = document.querySelector('.pdf_o canvas')
      let div_height = div.offsetHeight
      let cha = div_height / this.img_data.height
      for (var i = 0; i < this.imgs.length; i++) {
        this.imgs[i].pageIndex = Math.ceil(this.imgs[i].top / div_height) - 1
        this.imgs[i].sealId = this.imgs[i].id
        if (this.value == 3) {
          this.imgs[i].signLeft = (this.imgs[i].left / this.nws).toFixed(0)
        } else {
          this.imgs[i].signLeft = (this.imgs[i].left / this.value).toFixed(0)
        }

        this.imgs[i].contractId = this.contractId_one
        this.imgs[i].contractJoinUserId = this.contractJoinUserId
        this.imgs[i].sealUri = this.imgs[i].sealSaveID
        if (this.imgs[i].top < div_height) {
          if (div_height - this.imgs[i].top < this.imgs[i].height / 2) {
            var newtop = ((div_height - this.imgs[i].top) / cha).toFixed(0)
            this.imgs[i].signTop = '-' + newtop
            this.imgs[i].pageIndex = this.imgs[i].pageIndex + 1
          } else {
            this.imgs[i].signTop = (this.imgs[i].top / cha).toFixed(0)
          }
        } else {
          var a = (Math.ceil(this.imgs[i].top / div_height) - 1) * div_height
          if (div_height - (this.imgs[i].top - a) < this.imgs[i].height / 2) {
            var newtops = (div_height - (this.imgs[i].top - a) / cha).toFixed(0)
            this.imgs[i].signTop = '-' + newtops
            this.imgs[i].pageIndex = this.imgs[i].pageIndex + 1
          } else {
            this.imgs[i].signTop = ((this.imgs[i].top - a) / cha).toFixed(0)
          }
        }
      }
      this.$SIF.httpPost({
        url: this.$SIF._serve.contract + '/function/batch-add/contract-detail',
        data: [...this.imgs],
        succFun: res => {
          this.add_contract()
          // this.loading = false
        },
        failFun: res => {
          this.loading = false
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    // 获取短信验证码
    get_code() {
      this.loading_button = true
      this.$SIF.httpPost({
        url: this.$SIF._serve.manage + '/function/send/sign-security-code',
        data: {},
        succFun: res => {
          if (res.code == 10000) {
            this.verify_num()
            this.$message({
              message: res.msg,
              type: 'success'
            })
          } else {
            this.loading_button = false
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        },
        failFun: res => {
          this.loading_button = false
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    // 倒计时
    verify_num() {
      var time = this.time
      var that = this
      that.interval = setInterval(function () {
        if (time <= 1) {
          clearTimeout(that.interval)
          that.verify = true
          that.time = 60
          that.$set(that.user, 'code', '')
          that.loading_button = false
        } else {
          time--
          that.verify = false
          that.time = time
          that.loading_button = false
        }
      }, 1000)
      this.verify = true
      this.loading_button = true
    },
    // 验证验证码是否正确
    //
    sign_code() {
      this.disabled = true
      this.loading_yes = true
      this.loading = true
      this.$SIF.httpPost({
        url: this.$SIF._serve.manage + '/function/check/sign-security-code',
        data: {
          securityCode: this.user.code
        },
        succFun: res => {
          if (this.serial == 3) {
            // this.add_contract_detail()

            this.del_contract_detail()

            return
          }
          this.contract_issue()
          this.dialogVisible = false
          setTimeout(() => {
            this.loading_yes = false
          }, 2000)
        },
        failFun: res => {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
          setTimeout(() => {
            this.disabled = false
            this.loading_yes = false
          }, 2000)
          this.loading = false
        }
      })
    },
    // 批量签署
    //
    add_contract() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.manage + '/function/batch-sign/contract',
        data: {
          contractJoinUserId: this.contractJoinUserId,
          securityCode: this.user.code
        },
        succFun: res => {
          this.affirm_contract()
        },
        failFun: res => {
          this.loading = false
          this.disabled = false
          this.loading_yes = false
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    // 确认合同签署
    affirm_contract() {
      this.loading = true
      this.$SIF.httpPost({
        url: this.$SIF._serve.manage + '/contract/affirm/sign',
        data: {
          contractJoinUserId: this.contractJoinUserId
        },
        succFun: res => {
          if (res.code == 10000) {
            this.$message({
              message: '合同签署成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.$router.go(-2) //返回上一层
            this.loading = false
          } else {
            this.loading = false
            this.$message({
              message: res.msg,
              type: 'success'
            })
          }
        },
        failFun: res => {
          this.loading = false
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>

<style scoped type="text/css">
.top_div {
  height: 42px;
  line-height: 42px;
  background: #ffffff;
  text-align: center;
  font-size: 14px;
  color: #31ca84;
}

.onSliet_o_s {
  z-index: 100;
  text-align: center;
  width: 30px;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 6px;
}

.el_select {
  position: absolute;
  left: 70%;
  width: 100px;
}

.el_select >>> .el-input__inner {
  /*height: 30px;*/
}

.div_lang {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.el_row /deep/ .el-row {
  margin: 0 !important;
}

.el_row {
  width: 100%;
  height: -webkit-calc(100% - 61px);
  height: -moz-calc(100% - 61px);
  height: calc(100% - 61px);
  overflow: hidden;
  /*box-shadow: 1px 0px 4px 0px #bbafaf;*/
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  border-top: 1px solid #dcdfe6;
}

.detail_msg_m {
  /*height:-webkit-calc(100% - 65px);*/
  padding: 0;
}

.detail_msg_m {
  width: 759px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}

.detail_msg_mo {
  width: 100%;
  margin: 0 auto;
  background: #ffffff;
  padding: 10px 50px;
  overflow: hidden;
  box-shadow: 0px 2px 6px 0px rgba(135, 135, 135, 0.16);
}

.coil_test {
  width: 90%;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.bc_butn_o {
  height: 30px;
  background: rgba(49, 202, 132, 1);
  border-radius: 5px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  float: left;
  padding: 0 10px;
}

.detail_msg_test {
  width: 49%;
  float: left;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
  position: absolute;
  left: 25%;
}

.sign-header-img {
  width: 140px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.turn {
  width: 33%;
  float: left;
  text-align: center;
}

.turn_lifet {
  padding-left: 30px;
  text-align: left;
}

.turn_right {
  padding-right: 30px;
  text-align: right;
}

.tun_m {
  margin: 0;
  line-height: 40px;
}

.img_seal {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}

.img_seal >>> .el-image__inner--center {
  position: static !important;
  transform: translate(0%, 0%) !important;
}

.el-collapse_item /deep/ .el-collapse-item__content {
  text-align: center;
}

.previewP_main {
  padding-top: 53px;
  text-align: center;
}

.previewP_main img {
  width: 100px;
  height: 100px;
  position: relative;
}

.img {
  width: 100px;
  height: 100px;
  position: absolute;
  /*bottom: 150px;*/
  /*right: 100px;*/
  left: 100px;
  top: 100px;
  border: 1px solid #baebd5;
}

.img_ong:hover .delButn {
  display: block;
}

.delButn {
  position: absolute;
  width: 20px;
  height: 20px;
  color: rgba(49, 202, 132, 1);
  left: 190px;
  top: 90px;
  cursor: pointer;
  display: none;
  z-index: 10;
}

.Sign_immediately {
  margin-top: 30px;
  width: 100%;
  text-align: center;
  background: #ffffff;
  padding-bottom: 20px;
}

.Sign_immediately_top {
  color: #17a96a;
  font-size: 18px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  line-height: 48px;
  height: 48px;
  border-bottom: 1px solid #1d8b59;
}

.Sign_immediately_button {
  color: #565656;
  font-size: 18px;
  padding: 15px 0;
}

.verifyCode_one .input_one {
  width: 50%;
  float: left;
}

.butn {
  margin-left: 20px;
}

.Abbreviation {
  width: 100%;
  height: -webkit-calc(100% - 40px);
  height: -moz-calc(100% - 40px);
  height: calc(100% - 40px);
  background: #f3f6f7;
  padding-bottom: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #0fc87d;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #cdcdcd;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #0099dd;
  /*滚动条阴影*/
  scrollbar-shadow-color: #cdcdcd;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #fff;
  /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
  scrollbar-3dlight-color: #0099dd;
  /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
  scrollbar-darkshadow-color: #0099dd;
  /*滚动条基准颜色*/
  scrollbar-base-color: #0099dd;
}

.Abbreviation_div {
  height: 200px;
  padding-top: 20px;
}

.onSliet {
  border: 3px solid #31ca84;
}

.onSliet_o {
  background: #31ca84;
  color: #ffffff;
}

.Abbreviation_pdf {
  width: 70%;
  height: 70%;
  margin: 0 auto;
  display: block;
  text-align: center;
}

.Abbreviation_pdf /deep/ canvas {
  height: 100% !important;
}

.el-collapse-item {
  border-left: 4px solid #87ddb7;
  padding-left: 10px;
  border-radius: 15px;
  margin: 8px 0;
  border-top: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

.el_collapse {
  border: none;
}

.el-collapse /deep/ .is-active {
  border-left: 4px solid #0fc87d;
  padding-left: 10px;
}

.el-collapse_item /deep/ .is-active {
  border-left: none;
  padding-left: 0;
}

.want_sign {
  background: #31ca84;
  color: #ffffff;
  border-radius: 19px;
  width: 102px;
  height: 30px;
  padding: 0;
}

.want_sign_s {
  background: #ffffff;
  color: #4a4a4a;
}

.want_sign_1 {
  width: 50%;
  position: absolute;
  top: 40%;
  left: 30%;
  line-height: 30px;
}

.el-col_3 {
  border: 2px solid #f8f8f8;
  box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.05);
}

.Abbreviation::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}

.Abbreviation::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.Abbreviation::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.box_body {
  width: -webkit-calc(100% - 150px);
  width: -moz-calc(100% - 150px);
  width: calc(100% - 150px);
  height: -webkit-calc(100%);
  height: -moz-calc(100%);
  height: calc(100%);
  padding: 10px 0;
  transition: width 0.5s;
  overflow-x: auto;
  overflow-y: auto;
  background: rgba(243, 246, 247, 1);
  box-shadow: 0px 2px 6px 0px rgba(135, 135, 135, 0.16);
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #0fc87d;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #cdcdcd;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #0099dd;
  /*滚动条阴影*/
  scrollbar-shadow-color: #cdcdcd;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #fff;
  /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
  scrollbar-3dlight-color: #0099dd;
  /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
  scrollbar-darkshadow-color: #0099dd;
  /*滚动条基准颜色*/
  scrollbar-base-color: #0099dd;
  /*-moz-transition:width 2s; !* Firefox 4 *!*/
  /*-webkit-transition:width 2s; !* Safari and Chrome *!*/
  /*-o-transition:width 2s; !* Opera *!*/
  /*transition: all 1s;*/
}

.box_body::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.box_body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.el-row {
  width: 100%;
  height: 100%;
}

.box_body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.el-col_4 {
  height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: center;
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #0fc87d;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #cdcdcd;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #0099dd;
  /*滚动条阴影*/
  scrollbar-shadow-color: #cdcdcd;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #fff;
  /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
  scrollbar-3dlight-color: #0099dd;
  /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
  scrollbar-darkshadow-color: #0099dd;
  /*滚动条基准颜色*/
  scrollbar-base-color: #0099dd;
}

.el-col_4::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}

.el-col_4::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.el-col_4::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.el-menu-vertical-demo {
  height: 100%;
  background: rgba(248, 248, 248, 1);
  box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.05);
  /*overflow: hidden;*/
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 150px;
  min-height: 400px;
  float: left;
  transition: width 0.5s;
  overflow: hidden;
}

.el-menu-vertical-demo_0 {
  width: 0 !important;
  transition: width 1s;
}

.zhan {
  position: absolute;
  z-index: 14;
  left: 0;
  top: 40%;
  width: 11px;
  height: 221px;
  text-align: center;
  line-height: 221px;
  background: rgba(49, 202, 132, 1);
  color: #ffffff;
}

.el-col_17 {
  height: 100%;
  position: relative;
}

.el-col_17 .el-menu--collapse {
  width: 0;
}

.el-menu {
  height: 100%;
}

.el-menu--collapse .top_div {
  line-height: 16px;
}

.pdf_o {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 9px 0px rgba(191, 191, 191, 0.5);
}

.detail_msg_m {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 9px 0px rgba(191, 191, 191, 0.5);
  margin-top: 2px;
}

.detail_msg_test span {
  color: #0fc87d;
}

.detail_m_pdf {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 2px 9px 0px rgba(191, 191, 191, 0.5);
}

.tanzheng {
  color: #968e8e;
  font-size: 14px;
  padding: 15px 0;
  width: 100%;
  text-align: center;
}

.tanzheng span {
  color: #0fc87d;
}

.image-slot_one {
  padding-top: 33px;
}

.image-slot_one p {
  font-weight: 500;
  color: rgba(255, 118, 23, 1);
  line-height: 20px;
}

.div_lang >>> .el-loading-spinner {
  width: 200px;
  height: 200px;
  background: url(~@/assets/img/loding.gif) no-repeat;
  background-size: 50% 100%;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  animation: raise 4s ease-in-out infinite;
  top: 35%;
  left: 48%;
  position: relative;
}

.div_lang >>> .el-loading-spinner .circular {
  width: 42px;
  height: 42px;
  animation: loading-rotate 2s linear infinite;
  display: none;
}

.div_lang >>> .el-loading-mask {
  background-color: rgba(0, 0, 0, 0.5);
}

.el-tabs--border-card {
  border-top: none;
}
</style>
